import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import RcInputNumber from 'rc-input-number';
import { Icon } from '@digsup/components-icon';

import { styles } from './InputNumber.scss';

const cx = classNames.bind(styles);

const InputNumberComponent = ({
  isDisabled,
  hasError,
  isRequired,
  size,
  className,
  forwarderRef,
  isInlineEditable,
  isReadOnly,
  style,
  ...props
}) => {
  const classes = cx(
    {
      [`c-input-number--${size}`]: size,
      'c-input-number--disabled': isDisabled,
      'c-input-number--error': hasError,
      'c-input-number--read-only': isReadOnly,
    },
    className,
  );

  const upIcon = isReadOnly ? null : <HandlerIcon />;
  const downIcon = isReadOnly ? null : <HandlerIcon />;

  const inputElement = (
    <div className="c-input-number-wrapper" style={style}>
      <RcInputNumber
        prefixCls="c-input-number"
        className={classes}
        disabled={isDisabled}
        required={isRequired}
        upHandler={upIcon}
        downHandler={downIcon}
        readOnly={isReadOnly}
        ref={forwarderRef}
        {...props}
      />
      {isReadOnly && (
        <Icon
          name="padlock-locked"
          size="medium"
          className="c-input-number__read-only-icon"
        />
      )}
    </div>
  );

  if (isInlineEditable) {
    const wrapperClasses = cx('c-input-inline-editable-wrapper', {
      'c-input-inline-editable-wrapper--disabled': isDisabled,
      [`c-input-inline-editable-wrapper--${size}`]: size,
      'c-input-inline-editable-wrapper--error': hasError,
      'c-input-inline-editable-wrapper--read-only': isReadOnly,
    });

    return (
      <div className={wrapperClasses} title="Click to edit">
        {inputElement}
      </div>
    );
  }

  return inputElement;
};

const HandlerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 8">
    <path
      d="M1 7.001l3-3-3-3"
      data-name="Path 1985"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

export const InputNumber = React.forwardRef((props, ref) => (
  <InputNumberComponent {...props} forwarderRef={ref} />
));

InputNumber.propTypes = {
  isDisabled: PropTypes.bool,
  hasError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  isRequired: PropTypes.bool,

  placeholder: PropTypes.string,
  defaultValue: PropTypes.number,
  value: PropTypes.number,

  /*
   * Specifies the minimum value
   */
  min: PropTypes.number,
  /*
   * Specifies the maximum value
   */
  max: PropTypes.number,
  /*
   * Specifies the legal number intervals
   */
  step: PropTypes.number,

  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Inline editable mode
   */
  isInlineEditable: PropTypes.bool,
  /**
   * Prevents the user from changing the value of the field
   */
  isReadOnly: PropTypes.bool,
};

InputNumber.defaultProps = {
  isDisabled: false,
  hasError: false,
  size: 'medium',
  step: 1,
  isInlineEditable: false,
  isReadOnly: false,
};
